<template>
  <div class="activety-box">
    <div class="main">
      <img class="bg-img" src="./images/bg-rank.jpg" alt="" />
      <div class="top3-box">
        <div
          v-for="(item, index) of topList.slice(0, 3)"
          :key="index"
          class="item"
          :class="`top${index + 1}`"
          @click="toPlayerDetail(item)"
        >
          <template v-if="item">
            <img class="image-url" :src="item.imageUrl" alt="" srcset="" />
            <div class="content">{{ item.content }}</div>
            <div class="user-info">
              <img :src="item.avatarUrl" class="head-portrait" />
              <div class="user-name">{{ item.nikeName }}</div>
            </div>
            <div class="score">{{ item.votesNum }}票</div>
          </template>
        </div>
      </div>
      <div class="score-board-box">
        <div
          class="item"
          v-for="(item, index) of list.slice(3, 10)"
          :key="item.userUuid"
          @click="toPlayerDetail(item)"
        >
          <div class="left">
            <img class="image-url" :src="item.imageUrl" alt="" srcset="" />
            <div>
              <div class="content">{{ item.content }}</div>
              <div class="user-info">
                <img :src="item.avatarUrl" class="head-portrait" />
                <div class="user-name">{{ item.nikeName }}</div>
              </div>
              <div class="score">{{ item.votesNum }}票</div>
            </div>
          </div>
          <div class="right">
            <span class="index">NO.{{ index + 4 }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'Voting',
  props: {},
  data() {
    return {
      list: [],
      votesType: null
    };
  },
  watch: {},
  computed: {
    topList() {
      return this.list && this.list.length
        ? [this.list[1], this.list[0], this.list[2]]
        : [];
    }
  },
  methods: {
    toPlayerDetail(userInfo) {
      const { userUuid } = userInfo;
      if (userUuid) {
        this.$router.push({
          path: `/player-detail/${userUuid}`
        });
      }
    },
    getList() {
      this.$http
        .get('/votes/rank', { votesType: this.votesType })
        .then(res => {
          this.list = res.data || [];
        })
        .catch(() => {
          this.$message('獲取列表失敗');
        });
    }
  },
  created() {
    this.votesType = this.$route.params.type;
    this.getList();
  }
};
</script>
<style lang="scss" scoped>
.activety-box {
  width: 100%;
  height: 100vh;
  display: flex;
  background-color: #03002e;
  overflow: auto;
  justify-content: center;

  .main {
    position: relative;
    width: 750px;
    display: flex;
    flex-direction: column;
    min-height: 1038px;
    .bg-img {
      width: 100%;
      max-width: 100%;
    }
    .top3-box {
      position: absolute;
      top: dPx(298);
      width: 100%;
      display: flex;
      justify-content: space-between;
      padding: 0 32px;
      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        width: 218px;
        &:nth-child(1) {
          margin-top: 28px;
        }
        &:nth-child(3) {
          margin-top: 28px;
        }
        .image-url {
          width: 202px;
          height: 202px;
          border-radius: 32px;
          object-fit: cover;
          margin-top: 8px;
        }
        .content {
          font-weight: 400;
          font-size: 26px;
          text-align: center;
          color: #ffffff;
          width: 80%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
          line-height: 1.4;
          margin-top: 8px;
        }
        .user-info {
          display: flex;
          align-items: center;
          margin-top: 4px;
          .head-portrait {
            width: 34px;
            height: 34px;
            border-radius: 50%;
            margin-right: 4px;
          }
          .user-name {
            font-weight: 400;
            font-size: 22px;
            line-height: 15px;
            color: rgba(255, 255, 255, 0.77);
          }
        }
        .score {
          font-weight: 400;
          font-size: 18px;
          line-height: 18px;
          color: rgba(255, 255, 255, 0.77);
        }
      }
    }
    .score-board-box {
      display: flex;
      flex-direction: column;
      align-items: center;
      .item {
        width: dPx(343);
        height: dPx(80);
        background: rgba(255, 255, 255, 0.06);
        border-radius: 40px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        color: white;
        padding: 8px;
        margin-bottom: 8px;
        .left {
          display: flex;
          align-items: center;
        }
        .right {
          font-weight: 600;
          font-size: 30px;
          line-height: 42px;
          text-align: right;
          color: #ffcb46;
        }
        .image-url {
          width: dPx(72);
          height: dPx(72);
          border-radius: 32px;
          object-fit: cover;
          margin-right: 24px;
        }
        .content {
          font-size: 26px;
          max-width: 300px;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .user-info {
          display: flex;
          align-items: center;
          margin-top: 8px;
        }
        .head-portrait {
          width: 34px;
          height: 34px;
          border-radius: 50%;
          margin-right: 4px;
          object-fit: cover;
        }
        .user-name,
        .score {
          font-size: 22px;
          color: rgba(255, 255, 255, 0.77);
          margin-top: 10px;
        }
      }
    }
  }
}
</style>
